import { render } from "./LoginToken.vue?vue&type=template&id=5fbffad9&scoped=true"
import script from "./LoginToken.vue?vue&type=script&lang=js"
export * from "./LoginToken.vue?vue&type=script&lang=js"

import "./LoginToken.vue?vue&type=style&index=0&id=5fbffad9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbffad9"]])

export default __exports__